import React from 'react';
import './GivingSection.css';

/* Placeholder image. Swap for a real church photo before launch. */
const GIVING_IMAGE =
  'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80';

function GivingSection({
  onlineGivingUrl = 'https://thecitychurchluzira.churchcenter.com/giving',
  methodsId = 'give-methods',
}) {
  const openGiving = () =>
    window.open(onlineGivingUrl, '_blank', 'noopener,noreferrer');

  const scrollToMethods = () => {
    const el = document.getElementById(methodsId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="giving-section" aria-labelledby="giving-heading">
      <div className="giving-inner">
        <div className="giving-media">
          <img
            className="giving-image"
            src={GIVING_IMAGE}
            alt="A congregation worshipping together with hands raised"
            loading="lazy"
          />
        </div>

        <div className="giving-content">
          <h1 className="giving-heading" id="giving-heading">Giving</h1>

          <p className="giving-text">
            We believe Jesus is a giver and not a taker. Not only has He given us
            life and breath, but by His death and resurrection, He defeated the sin
            that would rob us of both. So, when it comes to giving, we believe
            percentages are a thing of the past, and obligation is the wrong approach.
          </p>
          <p className="giving-text">
            Giving is worship&mdash;and our worship is a response to the extravagant
            grace and glory of God.
          </p>

          <div className="giving-actions">
            <button
              type="button"
              className="giving-primary-btn"
              onClick={openGiving}
              aria-label="Give now, opens secure online giving in a new tab"
            >
              Give Now
            </button>

            <div className="giving-secondary-row">
              <button
                type="button"
                className="giving-secondary-btn giving-secondary-btn--outline"
                onClick={scrollToMethods}
              >
                Additional Giving Options
              </button>
              <button
                type="button"
                className="giving-secondary-btn giving-secondary-btn--solid"
                onClick={openGiving}
                aria-label="Returning givers, sign in to online giving"
              >
                Returning Givers
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GivingSection;
